import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import DownloadCenterTable from "./table";
import { Clients } from "@/lib/clients";
import { setDocumentTitle } from "@/lib/documentTitle";

export default function C5DownloadCenter() {
  const { t, i18n } = useTranslation(["titles"]);

  useEffect(() => {
    setDocumentTitle(
      t("quantilia_download_center", {
        ns: "titles",
        defaultValue: "Quantilia | Download Center",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Routes>
      <Route
        index
        element={
          <DownloadCenterTable
            client={Clients.C5}
            table_name={"c5_download_center"}
          />
        }
      />
    </Routes>
  );
}
